const breakpoints = [576, 768, 992, 1200]
const mq = breakpoints.map(bp => `@media (min-width: ${bp}px)`)

export const Screen = {
  XS: mq[0],
  S: mq[1],
  M: mq[2],
  L: mq[3],
}
